<div class="circle" [style]="{ width: size, height: size }"></div>
<div [style.font-size]="fontSize" class="exclamation">!</div>
